import React from "react";
import { Route, Routes } from "react-router-dom";
import { ModalRoot } from "./ModalRoot";
import { HomePage } from "./pages/HomePage";

export const App: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
      <ModalRoot />
    </>
  );
};
